import script from "./CookiesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookiesModal.vue?vue&type=script&setup=true&lang=ts"

import "./CookiesModal.vue?vue&type=style&index=0&id=1993e77a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1993e77a"]])

export default __exports__